import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import * as WorkOrderActionType from '../constants';
import EditBackCharge from '../Components/EditBackCharge';

class BackChargeDetail extends Component {

  static propTypes = {
    dispatch: PropTypes.func,
    match: PropTypes.object,
    userProfile: PropTypes.object,
    BackChargeProfile: PropTypes.object,
    location: PropTypes.string,
    history: PropTypes.func
  }

  constructor(props) {

    super(props);

    let rfsId = null;
    let workOrderId = null;
    let purchaseOrderId = null;
    let backChargeId = null;

    if (props.match.params.RFSID) {
      rfsId = props.match.params.RFSID;
    }

    if (props.match.params.WOID) {
      workOrderId = props.match.params.WOID;
    }

    if (props.match.params.POID) {
      purchaseOrderId = props.match.params.POID;
    }

    if (props.match.params.BCID) {
      backChargeId = props.match.params.BCID;
    }

    this.state = {
      rfsId,
      workOrderId,
      purchaseOrderId,
      backChargeId,
      isEditBackCharge: false
    };
  }

  componentDidMount() {
    this.fetchBackChargeDetail();
  }

  fetchBackChargeDetail = () => {
    const { rfsId, backChargeId } = this.state;
    this.props.dispatch({
      type: WorkOrderActionType.GET_BACK_CHARGE_DETAIL_ASYNC,
      params: {
        rfsRefNo: rfsId,
        refNo: backChargeId
      }
    });
  }

  handleCancel = () => {
    this.setState({isEditBackCharge: false});
  }

  onSelectChange = (event, name) => {
    this.setState({[name]: event.value});
  }

  onSubmit = () => {
    e.preventDefault();
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }

  onClickEditButton = () => {
    this.setState({isEditBackCharge: !this.state.isEditBackCharge});
  }

  renderBackChargeInfoValue(value, isDate, isMoney) {
    if (isDate) {
      if (value === null || value === 'null') {
        return <span style={{opacity: 0.5}}>(Not specified)</span>;
      }
      return <strong className='word-break-all'>{moment(value).format('MM/DD/YYYY')}</strong>;
    }

    if (isMoney) {
      if (value === null || value === 'null') {
        return <span style={{opacity: 0.5}}>(Not specified)</span>;
      }
      return <strong>{Number(value).toFixed(2)}</strong>;
    }

    if (value) {
      return <strong className='word-break-all'>{value}</strong>;
    }

    return <span style={{opacity: 0.5}}>(Not specified)</span>;
  }

  renderBackChargeInfo() {
    const {BackChargeProfile} = this.props;
    if (isEmpty(BackChargeProfile)) {
      return null;
    }
    return (
      <div className='box-form-siteone col-xs-12 col-lg-12 add-wo-form' style={{paddingTop: 20}}>
        <div className='row col-sm-12 form-group'>
          <label className='col-lg-2 col-md-3  col-sm-3 control-label'>Trade
          </label>
          <div className='col-lg-10 col-md-9 col-sm-9' style={{padding: '0 15px'}}>
            {this.renderBackChargeInfoValue(BackChargeProfile.trade.name)}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-lg-2  col-md-3 col-sm-3 control-label'>Charge to
          </label>
          <div className='col-lg-10 col-md-9 col-sm-9' style={{padding: '0 15px'}}>
            {this.renderBackChargeInfoValue(BackChargeProfile.subcontractor.companyName)}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-lg-2  col-md-3 col-sm-3 control-label'>Amount
          </label>
          <div className='col-lg-10 col-md-9 col-sm-9' style={{padding: '0 15px'}}>
            $ {this.renderBackChargeInfoValue(BackChargeProfile.amount, false, true)}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-lg-2  col-md-3 col-sm-3 control-label'>Reason for issuing BC
          </label>
          <div className='col-lg-10 col-md-9 col-sm-9' style={{padding: '0 15px'}}>
            {this.renderBackChargeInfoValue(BackChargeProfile.reason)}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-lg-2  col-md-3 col-sm-3 control-label'>Issued date
          </label>
          <div className='col-lg-10 col-md-9 col-sm-9' style={{padding: '0 15px'}}>
            {this.renderBackChargeInfoValue(BackChargeProfile.issuedDate, true)}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-lg-2  col-md-3 col-sm-3 control-label'>Issued by
          </label>
          <div className='col-lg-10 col-md-9 col-sm-9' style={{padding: '0 15px'}}>
            {this.renderBackChargeInfoValue(BackChargeProfile.issuedByUser.displayName)}
          </div>
        </div>

        <div className='row col-sm-12 form-group'>
          <label className='col-lg-2  col-md-3 col-sm-3 control-label'>Payment received
          </label>
          <div className='col-lg-10 col-md-9 col-sm-9' style={{padding: '0 15px'}}>
            {this.renderBackChargeInfoValue(BackChargeProfile.paymentDate, true)}
          </div>
        </div>

        <div className='col-sm-12 form-group'>
          <button className='btn btn-primary btn-siteone-default' onClick={this.onClickEditButton}>Edit</button>
        </div>

      </div>
    );
  }

  render() {

    return (
      <div className='rfs-detail add-new-work-order'>
        <div className='page-title clearfix'>
          <div>
            <h2 className='pull-left'>BC #{this.state.backChargeId}</h2>
          </div>
        </div>
        <ul className='breadcrumb'>
          <li><Link to={'/request-for-services'}>Requests for service</Link></li>
          <li><Link to={`/request-for-services/${this.state.rfsId}`}>RFS # {this.state.rfsId}</Link></li>
          <li><Link to={`/request-for-services/work-order/detail/${this.state.rfsId}/${this.state.workOrderId}`}>WO #{this.state.workOrderId}</Link></li>
          <li><Link to={`/request-for-services/work-order/purchase-order/${this.state.rfsId}/${this.state.workOrderId}/detail/${this.state.purchaseOrderId}`}>PO #{this.state.purchaseOrderId}</Link></li>
          <li className='breadcrumb-siteone-li'>BC #{this.state.backChargeId} </li>
        </ul>
        {
          !this.state.isEditBackCharge
            ? this.renderBackChargeInfo()
            : <EditBackCharge
              onSubmit={this.onSubmit}
              match={this.props.match}
              BackChargeProfile={this.props.BackChargeProfile}
              toggleEditMode={this.onClickEditButton}
            />
        }
        <iframe id='ifmcontentstoprint' style={{height: 0, border: 'none'}} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userProfile: state.UserStore.UserProfile,
    BackChargeProfile: state.WorkOrderReducer.BackChargeProfile
  };
};

export default connect(mapStateToProps)(BackChargeDetail);




// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/back-charge-detail.js